import { Code2, FileJson } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { CS_COURSES } from "src/config/diagnosticCourses";
import { AssessmentChoice } from "src/components/assessment/AssessmentChoice";

interface CsTrackSelectorProps {
  value: string | null;
  onChange: (courseId: string) => void;
}

const courseIcons: Record<string, LucideIcon> = {
  python: Code2,
  javascript: FileJson,
};

export function CsTrackSelector({ value, onChange }: CsTrackSelectorProps) {
  return (
    <div className="flex flex-col gap-3" role="group" aria-label="Computer science track">
      {CS_COURSES.map((course) => (
        <AssessmentChoice
          key={course.id}
          label={course.label}
          description={course.description}
          icon={courseIcons[course.id] ?? Code2}
          selected={value === course.id}
          disabled={!course.available}
          badge={course.available ? undefined : "Coming soon"}
          onClick={() => course.available && onChange(course.id)}
        />
      ))}
    </div>
  );
}

export default CsTrackSelector;
